const formatAppConfiguration = (config, appCode) => {
  const formattedConfig = config;
  if (appCode === 'afosto') {
    formattedConfig.channels = formattedConfig.channels.map(channel => ({
      ...channel,
      external_service_id: parseInt(channel.external_service_id, 10),
    }));
  }

  return formattedConfig;
};

export default formatAppConfiguration;
